namespace GeniuzPOS.InventoryReport {
    export namespace IcReport07SkuWhsService {
        export const baseUrl = 'InventoryReport/IcReport07SkuWhs';

        export declare function Create(request: Serenity.SaveRequest<IcReport07SkuWhsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<IcReport07SkuWhsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<IcReport07SkuWhsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<IcReport07SkuWhsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "InventoryReport/IcReport07SkuWhs/Create",
            Update = "InventoryReport/IcReport07SkuWhs/Update",
            Delete = "InventoryReport/IcReport07SkuWhs/Delete",
            Retrieve = "InventoryReport/IcReport07SkuWhs/Retrieve",
            List = "InventoryReport/IcReport07SkuWhs/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>IcReport07SkuWhsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
